import { render } from "./LeftNavbarRouter.vue?vue&type=template&id=437f5caa"
import script from "./LeftNavbarRouter.vue?vue&type=script&lang=js"
export * from "./LeftNavbarRouter.vue?vue&type=script&lang=js"

import "./LeftNavbarRouter.vue?vue&type=style&index=0&id=437f5caa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__